import { render, staticRenderFns } from "./addProcessDialog.vue?vue&type=template&id=1c8d0c66&lang=pug"
import script from "./addProcessDialog.vue?vue&type=script&lang=js"
export * from "./addProcessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports